import { axiosWithToken } from '../utils/functions/apiCallWithToken';
import axios from 'axios';
import { SERVER_URL as serverURL } from '../core/config';
import { reportApiError } from '../utils/functions/reportApiError';


export const fetchExchangeData = async () => {
    // Vague 4 lot 3 : axios brut CONSERVÉ — URL EXTERNE (api.coingecko.com) : un appel
    // externe ne passe pas par le client chiffré marketplace (aucun contrat AES/Bearer),
    // donc pas par reportApiError du client central. On instrumente ici (5xx/réseau) pour
    // que ce chemin, s'il est réactivé, ne soit pas un angle mort Sentry. Relaie l'erreur (§107).
    try {
        const result = await axios.get(
            'https://api.coingecko.com/api/v3/simple/price',
            {
                params: {
                    ids: 'metagamz',
                    vs_currencies: 'usd',
                },
            }
        );
        return result.data.metagamz.usd;
    } catch (err) {
        reportApiError(err, { url: 'coingecko/simple/price', method: 'get' });
        throw err;
    }
}

export const fetchContinents = async () => {
    const result = await axiosWithToken(`${serverURL}/data/continent/`, 'get', {});
    return result;
}

export const fetchTiers = async () => {
    const result = await axiosWithToken(`${serverURL}/data/tier/`, 'get', {});
    return result;
}

export const fetchSnapshot = async () => {
    const result = await axiosWithToken(`${serverURL}/data/snapshot/`, 'get', {});
    return result;
}

export const fetchSetting = async () => {
    const result = await axiosWithToken(`${serverURL}/data/setting/`, 'get', {});
    return result;
}

export const fetchCompany = async (wallet) => {
    const result = await axiosWithToken(`${serverURL}/data/company/${wallet}`, 'get', {});
    return result;
}

export const fetchRoles = async () => {
    const result = await axiosWithToken(`${serverURL}/data/roles/`, 'get', {});
    return result;
}

export const fetchUsername = async (username) => {
    const result = await axiosWithToken(`${serverURL}/data/username/${username}`, 'get', {});
    return result;
}

export const fetchEmail = async (email) => {
    const result = await axiosWithToken(`${serverURL}/data/email/${email}`, 'get', {});
    return result;
}

export const fetchAsset = async (title) => {
    const result = await axiosWithToken(`${serverURL}/data/asset/${title}`, 'get', {});
    return result;
}

export const fetchCompanies = async () => {
    const result = await axiosWithToken(`${serverURL}/data/company/`, 'get', {});
    return result;
}

export const fetchTiles = async (params) => {
    const result = await axiosWithToken(`${serverURL}/data/tile-map/tile/`, 'get', {}, params);
    return result;
}

export const fetchTilesLite = async (params) => {
    // mode=color : overview ULTRA-léger {x,y,c,o} (couleur calculée serveur). Le détail
    // complet du terrain est récupéré UNIQUEMENT au clic (fetchTiles). interesting=1 :
    // n'envoie que les tiles transactables (mer/sol = image de fond). Permet le dézoom
    // (zoom 1/2) rapide sur tous les niveaux.
    const result = await axiosWithToken(`${serverURL}/data/tile-map/tile-lite/`, 'get', {}, { ...params, interesting: 1, mode: 'color' });
    return result;
}

export const fetchContinentMask = async (continentId) => {
    // Masque (forme réelle) d'un continent : { minX, minY, w, h, bits(base64) }.
    // Utilisé pour peindre Earnicity en blanc (sa vraie forme) + y dessiner le logo.
    const result = await axiosWithToken(`${serverURL}/data/tile-map/continent-mask/`, 'get', {}, { continentId });
    return result;
}

export const fetchTileGroups = async (params) => {
    const result = await axiosWithToken(`${serverURL}/data/tile-map/tile-group/`, 'get', {}, params);
    return result;
}

export const fetchNumberOfUsers = async () => {
    const result = await axiosWithToken(`${serverURL}/data/number-of-registered`, 'get', {});
    return result;
}

// ─── Plafond fiat administrable (P1-1, TRACK-2026-07-03-refactor-vague1) ─────────────
// Source de vérité serveur = AppSettings.fiat_cap_usd ; le front garde FIAT_CAP_USD=2000
// (cartConstants) uniquement comme fallback réseau (cf. src/hooks/useFiatCap.js).

export const fetchFiatCap = async () => {
    const result = await axiosWithToken(`${serverURL}/data/fiat-cap/`, 'get', {});
    return result; // { fiatCapUsd }
}

export const fetchAdminFiatCap = async () => {
    const result = await axiosWithToken(`${serverURL}/data/admin/fiat-cap/`, 'get', {});
    return result; // { fiatCapUsd }
}

export const updateAdminFiatCap = async (fiatCapUsd) => {
    const result = await axiosWithToken(`${serverURL}/data/admin/fiat-cap/`, 'put', { fiatCapUsd });
    return result; // { fiatCapUsd }
}
